import React from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import { Grid, Typography } from '@material-ui/core/';

const useStyles = makeStyles({
  avatar: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    height: '36px',
    width: '36px',
    color: '#757575',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    lineHeight: '20px',
    backgroundColor: 'rgba(0, 0, 0, 0.12)'
  },
  appBarStyle: {
    backgroundColor: '#FFFFFF',
    minHeight: '54px',
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: '15px'
  },
  statusText: {
    fontSize: '12px',
    lineHeight: '16px',
    display: 'inline-block',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  activeButton: {
    color: '#00A645'
  },
  inActiveButton: {
    color: '#ff9800'
  },
  suspendedButton: {
    color: '#D50000'
  },
  pendingButton: {
    color: '#EE6600'
  },
  createTypography: {
    fontSize: '20px',
    lineHeight: '48px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  editTypography: {
    fontSize: '12px',
    lineHeight: '16px',
    display: 'inline-block',
    marginRight: '5px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  nameTypography: {
    fontSize: '20px',
    lineHeight: '20px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatarItem: {
    paddingRight: '4px'
  },
  nameDiv: {
    paddingLeft: '4px'
  },
  containerDiv: {
    display: 'flex'
  },
  containerGrid: {
    justifyContent: 'space-between'
  },
  loginUserDiv: {
    alignSelf: 'center',
    paddingBottom: '5px'
  },
  downloadAsExcelButton: {
    right: '0px',
    marginTop: '23px'
  },
  labelButton: {
    whiteSpace: 'nowrap'
  },
  button: {
    marginTop: '23px'
  }
});

const formatStatus = status => {
  return status.charAt(0).toUpperCase() + status.substring(1).toLowerCase();
};

const StatusText = ({ status, statusLabel }) => {
  const classes = useStyles();
  let optionClass = '';
  switch (status) {
    case 'ACTIVE':
    case 'A':
      optionClass = classes.statusText + ' ' + classes.activeButton;
      break;
    case 'INVITED':
    case 'PENDING':
    case 'P':
      optionClass = classes.statusText + ' ' + classes.pendingButton;
      break;
    case 'INACTIVE':
    case 'OFFLINE':
      optionClass = classes.statusText + ' ' + classes.inActiveButton;
      break;
    case 'SUSPENDED':
    case 'S':
      optionClass = classes.statusText + ' ' + classes.suspendedButton;
      break;
    default:
      break;
  }

  return (
    <div className={classes.statusText}>
      <Typography
        style={{
          fontSize: '12px',
          lineHeight: '16px',
          display: 'inline-block',
          marginRight: '5px'
        }}
      >
        {statusLabel}
      </Typography>
      <div className={optionClass} data-testid={'status-container'}>
        {formatStatus(status)}
      </div>
    </div>
  );
};

const FormTitleBar = ({
  recordLabel,
  name,
  loginUserId,
  status,
  creation,
  statusLabel,
  showAvatar,
  avatarContent,
  showButton,
  buttonLabel,
  onButtonClick,
  isLoading,
  id
}) => {
  const classes = useStyles();
  const nameClass = status ? classes.nameTypography : classes.createTypography;

  return (
    <Toolbar position="static" className={classes.appBarStyle}>
      <Grid
        container
        spacing={1}
        wrap={'nowrap'}
        className={classes.containerGrid}
      >
        <div className={classes.containerDiv}>
          {showAvatar ? (
            <Grid item className={classes.avatarItem}>
              <Avatar className={classes.avatar}>{avatarContent}</Avatar>
            </Grid>
          ) : (
            <></>
          )}
          <div className={classes.nameDiv}>
            {creation ? (
              <Grid item>
                <Typography
                  className={classes.createTypography}
                  data-testid={'recordLabel'}
                >
                  New {recordLabel}
                </Typography>
              </Grid>
            ) : (
              <Grid item className={!status ? classes.nameContainer : ''}>
                {recordLabel ? (
                  <Typography
                    className={classes.editTypography}
                    color="inherit"
                    data-testid={'recordLabel'}
                  >
                    {recordLabel}
                  </Typography>
                ) : (
                  <></>
                )}
                {status ? (
                  <StatusText status={status} statusLabel={statusLabel} />
                ) : (
                  <></>
                )}
                <Typography className={nameClass}>{name}</Typography>
              </Grid>
            )}
          </div>
        </div>
        <div className={classes.loginUserDiv}>
          {loginUserId ? (
            <Typography
              className={classes.editTypography}
              data-testid={'loginUserId'}
            >
              {loginUserId}
            </Typography>
          ) : (
            <></>
          )}
        </div>
        {showButton ? (
          <div style={{ marginTop: '7px' }}>
            <Button
              color="primary"
              variant="outlined"
              classes={{ label: classes.labelButton }}
              onClick={isLoading ? null : onButtonClick}
              disabled={isLoading}
              id={id}
            >
              {buttonLabel}
            </Button>
          </div>
        ) : (
          <></>
        )}
      </Grid>
    </Toolbar>
  );
};

export default FormTitleBar;
